import { LitElement, PropertyValueMap, html } from "lit";
import { customElement } from "lit/decorators.js";
import { i18n } from "./utils/i18n.js";
import { setupLiveReload } from "./utils/live-reload.js";
import { router } from "./utils/routing.js";
import { Api } from "./api.js";
export * from "./pages/index.js";
export * from "./utils/ui-components.js";

setupLiveReload();

@customElement("app-main")
export class App extends LitElement {
    constructor() {
        super();
    }

    protected createRenderRoot(): Element | ShadowRoot {
        return this;
    }

    protected async firstUpdated(_changedProperties: PropertyValueMap<any> | Map<PropertyKey, unknown>): Promise<void> {
        super.firstUpdated(_changedProperties);
        router.addRoute(
            "/",
            () => html`<landing-page></landing-page>`,
            () => "WaveMind"
        );
        router.addRoute(
            "/search",
            () => html`<search-page></search-page>`,
            () => "WaveMind"
        );
        router.addRoute(
            "/register",
            () => html`<register-page></register-page>`,
            () => "WaveMind"
        );
        router.addRoute(
            "/404",
            () => {
                window.location.href = "/";
                return html``;
            },
            () => "404"
        );
        router.addRoute(
            "/index-builder",
            () => html`<index-builder-page></index-builder-page>`,
            () => "Index Builder"
        );

        if (location.pathname.startsWith("/admin")) {
            try {
                const user = await Api.me();
                if (user?.role !== "admin") {
                    window.location.href = "/";
                    return;
                }
            } catch (e) {
                window.location.href = "/";
                return;
            }
            router.addRoute(
                "/admin",
                () => html`<admin-dashboard></admin-dashboard>`,
                () => "Admin Dashboard"
            );

            router.addRoute(
                "/admin/users/:id",
                () => html`<user-page></user-page>`,
                () => "User Details"
            );

            router.addRoute(
                "/admin/users",
                () => html`<admin-users></admin-users>`,
                () => "User Management"
            );

            router.addRoute(
                "/admin/searches",
                () => html`<admin-searches></admin-searches>`,
                () => "Search Analytics"
            );

            router.addRoute(
                "/admin/completions",
                () => html`<admin-completions></admin-completions>`,
                () => "Completion Analytics"
            );

            router.addRoute(
                "/admin/chats",
                () => html`<admin-chat-sessions></admin-chat-sessions>`,
                () => "Chat Sessions"
            );

            router.addRoute(
                "/admin/sql",
                () => html`<admin-sql></admin-sql>`,
                () => "SQL Console"
            );
        }

        router.setRootRoute("/");
        router.setNotFoundRoot("/404");
        router.replace(location.href);
    }
}
